const handleDateClick = (event: any) => {
	console.log('DateClick', event);
};

export default handleDateClick;
